module.exports = __webpack_public_path__ + "img/vonexLogo.c95304a5.png";